"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pick = pick;
// The generic needs `object` here to preserve current call-site inference without widening to unsafe types.
// eslint-disable-next-line @typescript-eslint/ban-types
function pick(value, keys) {
    const result = {};
    for (const key of keys) {
        if (Object.hasOwn(value, key)) {
            result[key] = value[key];
        }
    }
    return result;
}
//# sourceMappingURL=pick.js.map